import { NgModule } from '@angular/core';
import { DxAutocompleteModule } from 'devextreme-angular/ui/autocomplete';
import { DxPopupModule } from 'devextreme-angular/ui/popup';
import { DxDropDownBoxModule } from 'devextreme-angular/ui/drop-down-box';
import { CommonService } from '../core/services/common.service';
import { SharedModule } from '../shared/shared.module';
import {
  GroupDropdownComponent,
  FuturesMonitorComponent
} from './components';
import { FormsModule } from '@angular/forms';
import { ChartsModule } from '../charts/charts.module';
import { CalculatorsModule } from '../calculators/calculators.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CommonModule } from '@angular/common';
import { FuturesMonitorService } from './services/futures-monitor.service';
import { CreditModule } from '../credit/credit.module';
import { AdvancedSearchModule } from 'app/advanced-search/advanced-search.module';

@NgModule({
  declarations: [
    FuturesMonitorComponent,
    GroupDropdownComponent
  ],
  imports: [
    CommonModule,
    DxAutocompleteModule,
    DxPopupModule,
    DxDropDownBoxModule,
    SharedModule,
    FormsModule,
    ChartsModule,
    CalculatorsModule,
    NgxSpinnerModule,
    CreditModule,
    AdvancedSearchModule
  ],
  exports: [
    FuturesMonitorComponent
  ],
  entryComponents: [FuturesMonitorComponent],
  providers: [
    CommonService,
    FuturesMonitorService
  ]
})
export class FuturesMonitorModule {
}
